export default "__VITE_ASSET__BsRAX6IV__"